// Disable right-click context menu
function disableRightClick(e) {
    e.preventDefault();
  }
  
  document.addEventListener('contextmenu', disableRightClick);
  